<div class="row h-100 noMarginLeftRight">
  <div class="col-8">
    <mat-tab-group
      #tabGroup
      (selectedTabChange)="tabChanged($event)"
      [selectedIndex]="selected.value"
      (selectedIndexChange)="selected.setValue($event)"
      headerPosition="above"
    >
      <mat-tab>
        <ng-template mat-tab-label class="iconTabs">
          <mat-icon *ngIf="finishOne" class="colorIcon unselectable" matSuffix
            >done</mat-icon
          >
          <mat-icon *ngIf="!finishOne" class="example-tab-icon unselectable"
            >bar_chart</mat-icon
          >
        </ng-template>
        <div class="container">
          <div class="nextContainer">
            <button
              mat-raised-button
              class="primaryBtn"
              [disabled]="selectedChart === null"
              (click)="next(1)"
            >
              {{ "TAB_STEPPER.NEXT" | translate }}
            </button>
          </div>
          <div class="headerTabStepper">
            <div class="subTitleTab">
              {{ "TAB_STEPPER.NEW_GRAPHIC_FIRST_STEP" | translate }}
            </div>
            <div class="titleTab">
              {{ "TAB_STEPPER.GRAHIC_TYPE" | translate }}
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-4"
              style="text-align: center"
              *ngFor="let graphic of graphics"
              (click)="selectChart(graphic)"
            >
              <div class="graphic-type unselectable">
                <div class="graphic-circle-container">
                  <i
                    class="material-icons graphic-icon"
                    [class.selected]="getWidgetType(graphic, selectedChart)"
                    >{{ graphic.icon }}</i
                  >
                </div>
                <div class="graphic-icon-title">
                  {{ graphic.name | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab [ngClass]="finishTwo ? 'btnForm' : ''" [disabled]="!finishOne">
        <ng-template mat-tab-label class="iconTabs">
          <mat-icon class="example-tab-icon unselectable">
            <mat-icon *ngIf="finishTwo" class="unselectable" matSuffix
              >done</mat-icon
            >
            <app-svg *ngIf="!finishTwo" name="device"></app-svg>
          </mat-icon>
        </ng-template>
        <div class="container">
          <div class="nextContainer">
            <button
              *ngIf="!isATable && !isADigital"
              mat-raised-button
              class="primaryBtn"
              [disabled]="
                selectedDeviceList.length < 1 || dataTypeSelected.length < 1
              "
              (click)="next(2)"
            >
              {{ "TAB_STEPPER.NEXT" | translate }}
            </button>
            <button
              *ngIf="isATable || isADigital"
              mat-raised-button
              class="primaryBtn"
              [disabled]="
                selectedDeviceList.length < 1 || dataTypeSelected.length < 1
              "
              (click)="generateChartElement()"
            >
              {{ "TAB_STEPPER.GENERATE_WIDGET" | translate }}
            </button>
          </div>

          <div class="headerTabStepper">
            <div class="subTitleTab">
              {{ "TAB_STEPPER.NEW_GRAPHIC_SECOND_STEP" | translate }}
            </div>
            <div class="titleTab">
              {{ "TAB_STEPPER.DEVICE_AND_DATATYPE" | translate }}
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <button class="sausageSelectBtn" [matMenuTriggerFor]="menu">
                <div>
                  <p>{{ "TAB_STEPPER.SELECT_FACTORY" | translate }}</p>
                  <mat-menu #menu class="factorySelectionMenu userMenu">
                    <div *ngFor="let factory of factoryCollection?.collection">
                      <mat-checkbox
                        [checked]="factory.selected"
                        class="mat-menu-item factoryMenu"
                        (click)="selectFactoryEvent(factory)"
                        >{{ factory.name }}</mat-checkbox
                      >
                    </div>
                  </mat-menu>
                </div>
              </button>
              <div class="space20"></div>
              <div *ngIf="factoriesSelected?.collection?.length < 1">
                <div class="container mtop5">
                  <div class="text-center">
                    <app-svg name="no-factory"></app-svg>
                  </div>
                  <div class="text-center warning-factories">
                    <h3>{{ "WARNING_MESSAGES.NO_DEVICES" | translate }}</h3>
                    <p>{{ "TAB_STEPPER.CLICK_TO_ADD_FACTORY" | translate }}</p>
                  </div>
                </div>
              </div>
              <mat-tab-group
                animationDuration="0"
                *ngIf="factoriesSelected?.collection?.length > 0"
                [selectedIndex]="selectedFactory.value"
                (selectedIndexChange)="selectedFactory.setValue($event)"
              >
                <div
                  *ngFor="
                    let factory of factoriesSelected?.collection;
                    let i = index
                  "
                >
                  <mat-tab [label]="factory.descripcion">
                    <div class="container mtop5">
                      <div class="row">
                        <div class="col-md-12 mBottom5">
                          <app-graphis-devices-hierarchi
                            [title]="title[i]"
                            [deviceChildrenList]="childrens[i]"
                            (deviceItemSelected)="
                              selectedDeviceGraphItem($event)
                            "
                            (deviceItemUnSelected)="
                              unSelectedDeviceGraphItem($event)
                            "
                            (deviceItemNavegate)="navigate($event, i)"
                            (goBackOnDevices)="goBack(i)"
                            [loadingChildren]="loading[i]"
                            [isRoot]="isRoot[i]"
                          >
                          </app-graphis-devices-hierarchi>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                </div>
              </mat-tab-group>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab *ngIf="!isATable && !isADigital" [disabled]="!finishTwo">
        <ng-template mat-tab-label class="iconTabs">
          <mat-icon *ngIf="finishTwo" class="unselectable" matSuffix
            >done</mat-icon
          >
          <mat-icon
            *ngIf="!finishTwo && !isAGauge"
            class="unselectable"
            matSuffix
            >today</mat-icon
          >
          <mat-icon
            *ngIf="!finishTwo && isAGauge"
            class="unselectable"
            matSuffix
            >settings</mat-icon
          >
        </ng-template>
        <div class="container minHeight">
          <div class="nextContainer">
            <button
              *ngIf="isAGauge"
              mat-raised-button
              class="primaryBtn"
              [disabled]="validateSecondTabStep(isAGauge)"
              (click)="generateChartElement()"
            >
              {{ "TAB_STEPPER.GENERATE_WIDGET" | translate }}
            </button>
            <button
              *ngIf="!isAGauge"
              mat-raised-button
              class="primaryBtn"
              [disabled]="validateSelectDateRange"
              (click)="generateChartElement()"
            >
              {{ "TAB_STEPPER.GENERATE_GRAPHIC" | translate }}
            </button>
          </div>
          <div class="headerTabStepper">
            <div class="subTitleTab">
              {{ "TAB_STEPPER.NEW_GRAPHIC_THIRD_STEP" | translate }}
            </div>
            <div *ngIf="!isAGauge" class="titleTab">
              {{ "TAB_STEPPER.DATE_RANGE" | translate }}
            </div>
            <div *ngIf="isAGauge" class="titleTab">
              {{ "TAB_STEPPER.SPEEDOMETER_PARAMS" | translate }}
            </div>
          </div>

          <mat-radio-group
            *ngIf="!isAGauge"
            [(ngModel)]="dateRangeType"
            (change)="changeDateRangeTypeOption($event)"
          >
            <div *ngIf="!isDashboard" class="col-md-6 dib">
              <mat-radio-button [color]="'primary'" value="custom">
                {{ "TAB_STEPPER.CUSTOM_DATE" | translate }}
              </mat-radio-button>
            </div>
            <div class="col-md-6 dib">
              <mat-radio-button [color]="'primary'" value="period">
                {{ "TAB_STEPPER.CHOOSE_PERIOD" | translate }}
              </mat-radio-button>
            </div>
          </mat-radio-group>

          <app-calendar
            *ngIf="dateRangeType === 'custom' && !isAGauge"
            [reset]="reset"
            (fromEmitted)="getDateFrom($event)"
            (toEmitted)="getDateTo($event)"
          >
          </app-calendar>

          <app-period-selector
            *ngIf="dateRangeType === 'period' && !isAGauge"
            (selectionTimeRangeValue)="getSelectionTimeRangeValue($event)"
            (selectionPeriodValue)="getSelectionPeriodValue($event)"
          ></app-period-selector>

          <div *ngIf="isAGauge" style="font-size: medium">
            <form class="example-form">
              <mat-form-field class="example-full-width col-md-4">
                <mat-label>{{
                  "TAB_STEPPER.GAUGE_PARAMETERS.MIN" | translate
                }}</mat-label>
                <input matInput [formControl]="minFormControl" type="number" />
                <mat-error *ngIf="minFormControl.hasError('required')">
                  {{ "TAB_STEPPER.GAUGE_PARAMETERS.MIN_REQUIRED" | translate }}
                </mat-error>
                <mat-error *ngIf="minFormControl.hasError('overmin')">
                  {{ "TAB_STEPPER.GAUGE_PARAMETERS.OVERMIN" | translate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field class="example-full-width col-md-4">
                <mat-label>{{
                  "TAB_STEPPER.GAUGE_PARAMETERS.MAX" | translate
                }}</mat-label>
                <input matInput [formControl]="maxFormControl" type="number" />
                <mat-error *ngIf="maxFormControl.hasError('required')">
                  {{ "TAB_STEPPER.GAUGE_PARAMETERS.MAX_REQUIRED" | translate }}
                </mat-error>
                <mat-error *ngIf="maxFormControl.hasError('undermax')">
                  {{ "TAB_STEPPER.GAUGE_PARAMETERS.UNDERMAX" | translate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field class="example-full-width col-md-4">
                <mat-label>{{
                  "TAB_STEPPER.GAUGE_PARAMETERS.LIMIT" | translate
                }}</mat-label>
                <input
                  matInput
                  [formControl]="limitFormControl"
                  type="number"
                />
                <mat-error *ngIf="limitFormControl.hasError('required')">
                  {{
                    "TAB_STEPPER.GAUGE_PARAMETERS.LIMIT_REQUIRED" | translate
                  }}
                </mat-error>
                <mat-error *ngIf="limitFormControl.hasError('overlimit')">
                  {{ "TAB_STEPPER.GAUGE_PARAMETERS.OVERLIMIT" | translate }}
                </mat-error>
              </mat-form-field>
            </form>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="col-4 resumeSection noPaddingLeft">
    <div class="space25"></div>
    <div class="arrow-left"></div>
    <div class="container paddSides45">
      <div>
        <ul class="list-inline">
          <li
            class="list-inline-item"
            style="width: 75%; display: inline-block"
          >
            <div *ngIf="!enableTitleEdition">
              <b class="resumeTitleSection">{{
                "TAB_STEPPER.GRAPHIC_TITLE" | translate
              }}</b>
              <p *ngIf="isDashboard && !isTitleGenerated()">
                {{ chartTitleAux | translate }}
              </p>
              <p *ngIf="!isDashboard && !isTitleGenerated()">
                {{ chartTitleAux | translate }}
              </p>
              <p *ngIf="isDashboard && chartTitle">
                {{ chartTitle | translate }}
              </p>
              <!-- <p *ngIf="!isDashboard && chartTitle">{{ chartTitle | translate }}</p> -->
              <p *ngIf="!isDashboard && chartTitle">
                <span *ngFor="let td of tituloGrafico; index as i">
                  <span *ngIf="i < tituloGrafico.length - 1"> {{ td }}, </span>
                  <span *ngIf="i == tituloGrafico.length - 1">
                    {{ " " }} {{ td }}
                  </span>
                </span>
                <span>
                  {{ "OTHERS.OF_DEVICES" | translate }}
                </span>
                <span *ngFor="let disp of selectedDeviceList; index as i">
                  <span *ngIf="i < selectedDeviceList.length - 1"
                    >{{ disp.name }},
                  </span>
                  <span *ngIf="i == selectedDeviceList.length - 1"
                    >{{ " " }} {{ disp.name }}.</span
                  >
                </span>
              </p>
            </div>
            <mat-form-field class="fullWidth" *ngIf="enableTitleEdition">
              <input
                matInput
                (keypress)="validateKey($event)"
                [(ngModel)]="chartTitle"
                #inputChartTitle
              />
            </mat-form-field>
          </li>
          <li
            class="list-inline-item"
            style="width: 20%; display: inline-block"
          >
            <button
              *ngIf="finishTwo"
              (click)="editTitle()"
              mat-icon-button
              style="width: 100%"
            >
              <mat-icon class="editIcon">edit</mat-icon>
            </button>
          </li>
        </ul>
      </div>
      <div>
        <div class="resumeTitleSection">
          {{ "TAB_STEPPER.GRAPHIC_TYPE_RESUME" | translate }}
        </div>
        <div class="space15"></div>

        <mat-list-item>
          <div class="peview-item col-12">
            <i class="material-icons">{{ selectedChart?.icon }}</i>
            <span> {{ selectedChart?.name | translate }}</span>
          </div>
        </mat-list-item>
      </div>
      <div class="space15"></div>
      <div *ngIf="finishOne" class="resumeTitleSection larger">
        {{ "TAB_STEPPER.DEVICES" | translate }}
      </div>
      <mat-form-field *ngIf="finishOne" class="fullWidth">
        <div>
          <p *ngIf="selectedDeviceList.length > 0" class="text-left">
            {{ "TAB_STEPPER.DEVICES_SELECTED" | translate }}
          </p>
          <p
            title="Este campo es requerido"
            *ngIf="selectedDeviceList.length < 1"
            class="text-left"
          >
            {{ "TAB_STEPPER.NO_DEVICES_SELECTED" | translate
            }}<span title="Este campo es requerido" class="required">*</span>
          </p>
          <mat-chip-list #chipList>
            <mat-chip
              class="unselectable btnForm"
              *ngFor="let device of selectedDeviceList"
              (removed)="removeChipset(device)"
            >
              {{ device.name }}
              <mat-icon
                *ngIf="!isTitleGenerated()"
                class="chipsetCancel"
                matChipRemove
                >cancel</mat-icon
              >
            </mat-chip>
          </mat-chip-list>
        </div>
      </mat-form-field>
      <div class="space15"></div>
      <div *ngIf="finishOne">
        <div class="resumeTitleSection larger">
          {{ "TAB_STEPPER.DATATYPES" | translate }}
        </div>
        <div class="space10"></div>
        <div class="containerMatChips">
          <p
            *ngIf="
              dataTypeSelected !== null &&
              dataTypeSelected !== undefined &&
              dataTypeSelected.length > 0
            "
          >
            {{ "TAB_STEPPER.DATATYPE_SELECTED" | translate }}
          </p>
          <p
            title="Este campo es requerido"
            *ngIf="
              dataTypeSelected === null ||
              dataTypeSelected === undefined ||
              dataTypeSelected.length == 0
            "
            class="text-left"
          >
            {{ "TAB_STEPPER.NO_DATATYPES_SELECTED" | translate }}
            <span title="Este campo es requerido" class="required">*</span>
          </p>
          <div
            *ngIf="dataTypeSelected !== null && dataTypeSelected !== undefined"
          >
            <div *ngFor="let item of dataTypeSelected | uniqueDataTypeByCode">
              <mat-chip
                class="unselectable btnForm margin4"
                *ngIf="item?.name !== null"
                >{{ item?.name }}
              </mat-chip>
            </div>
          </div>
        </div>
        <div class="space20"></div>

        <div class="heightDatatype" *ngIf="availableSecond">
          <!-- //TODO Error de tipado -->

          <app-datatype-navigate
            [dataTypeSelectedCollection]="dataTypeSelected"
            [dataTypeChildrenList]="dataTypeTree"
            [deviceDatatype]="devicesSelectedSubject | async"
            (datatypeItemSelected)="selectedDatatype($event)"
            (datatypeItemUnSelected)="unSelectedDatatype($event)"
          >
          </app-datatype-navigate>
        </div>
      </div>

      <div class="space15"></div>
      <div *ngIf="finishTwo && !isAGauge && !isADigital">
        <div class="resumeTitleSection">
          <span>{{ "TAB_STEPPER.DATE_RANGE_RESUME" | translate }}</span>
        </div>
        <div class="space15"></div>
        <mat-list-item>
          <div class="peview-item col-12">
            <i class="material-icons">today</i>
            <span *ngIf="dateRangeType === 'custom'">{{
              "TAB_STEPPER.FROM" | translate
            }}</span>
            <span *ngIf="fromDate">
              {{ fromDate | date: "LLL dd, yyyy, HH:mm:ss a" }}</span
            >
            <span *ngIf="dateRangeType === 'period'">
              {{ "TAB_STEPPER.RANGE" | translate }}:
              {{ comboPeriodValueSelected | translate }}</span
            >
          </div>
        </mat-list-item>
        <div class="space15"></div>
        <mat-list-item>
          <div class="peview-item col-12">
            <i class="material-icons">today</i>
            <span *ngIf="dateRangeType === 'custom'">{{
              "TAB_STEPPER.TO" | translate
            }}</span>
            <span *ngIf="toDate">
              {{ toDate | date: "LLL dd, yyyy, HH:mm:ss a" }}
            </span>
            <span *ngIf="dateRangeType === 'period'">
              {{ "TAB_STEPPER.QUANTITY" | translate }}:
              {{ comboTimeRangeValueSelected }}</span
            >
          </div>
        </mat-list-item>
      </div>

      <div *ngIf="finishTwo && isAGauge">
        <div class="resumeTitleSection">
          <span>{{ "TAB_STEPPER.SPEEDOMETER_PARAMS" | translate }}</span>
        </div>
        <div class="space15"></div>
        <mat-list-item>
          <div class="peview-item col-12">
            <app-svg name="min"></app-svg>
            <span class="marginLeft1em"
              >{{ "TAB_STEPPER.GAUGE_PARAMETERS.MIN" | translate }}:
            </span>
            <span>{{ minFormControl?.value }}</span>
          </div>
        </mat-list-item>
        <div class="space15"></div>
        <mat-list-item>
          <div class="peview-item col-12">
            <app-svg name="max"></app-svg>
            <span class="marginLeft1em"
              >{{ "TAB_STEPPER.GAUGE_PARAMETERS.MAX" | translate }}:
            </span>
            <span>{{ maxFormControl?.value }}</span>
          </div>
        </mat-list-item>
        <div class="space15"></div>
        <mat-list-item>
          <div class="peview-item col-12">
            <app-svg name="limit"></app-svg>
            <span class="marginLeft1em"
              >{{ "TAB_STEPPER.GAUGE_PARAMETERS.LIMIT" | translate }}:
            </span>
            <span>{{ limitFormControl?.value }}</span>
          </div>
        </mat-list-item>
      </div>

      <div class="space15"></div>
    </div>
  </div>
</div>
